export const CHANGE_SUBCATEGORY_SELECTED_SUCCESS =
  "CHANGE_PLACE_SUBCATEGORY_SELECTED_SUCCESS";
